<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="description"
            name="nombre"
            v-model="form.nombre"
            :label="$t('cobrox.compra.labels.nombre')"
            :placeholder="$t('cobrox.compra.labels.nombre')"
            :error="hasInputErrors('nombre')"
            :error-messages="getInputErrors('nombre')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="verified"
            name="nombreLegal"
            v-model="form.nombreLegal"
            :label="$t('cobrox.compra.labels.nombreLegal')"
            :placeholder="$t('cobrox.compra.labels.nombreLegal')"
            :error="hasInputErrors('nombreLegal')"
            :error-messages="getInputErrors('nombreLegal')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <date-input
            v-model="form.fechaCompra"
            :label="$t('cobrox.compra.labels.fechaCompra')"
            :error="hasInputErrors('fechaCompra')"
            :error-messages="getInputErrors('fechaCompra')"
        ></date-input>

      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="donut_small"
            name="porcentajeCompra"
            v-model.number="form.porcentajeCompra"
            type="number"
            :label="$t('cobrox.compra.labels.porcentajeCompra')"
            :placeholder="$t('cobrox.compra.labels.porcentajeCompra')"
            :error="hasInputErrors('porcentajeCompra')"
            :error-messages="getInputErrors('porcentajeCompra')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="business"
            name="cuit"
            v-model="form.cuit"
            :label="$t('cobrox.compra.labels.cuit')"
            :placeholder="$t('cobrox.compra.labels.cuit')"
            :error="hasInputErrors('cuit')"
            :error-messages="getInputErrors('cuit')"
            color="secondary"

        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="location_on"
            name="direccionLegal"
            v-model="form.direccionLegal"
            :label="$t('cobrox.compra.labels.direccionLegal')"
            :placeholder="$t('cobrox.compra.labels.direccionLegal')"
            :error="hasInputErrors('direccionLegal')"
            :error-messages="getInputErrors('direccionLegal')"
            color="secondary"

        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="credit_score"
            name="debitable"
            v-model="form.debitable"
            :label="$t('cobrox.deuda.labels.debitable')"
            :error="hasInputErrors('debitable')"
            :error-messages="getInputErrors('debitable')"
            color="secondary"

        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="6">
        <v-select
            prepend-icon="account_balance"
            name="estrategiaLiquidacion"
            v-model="form.estrategiaLiquidacion"
            :items="estrategiasLiquidacion"
            item-text="text"
            item-value="value"
            :label="$t('cobrox.compra.labels.estrategiaLiquidacion')"
            :error="hasInputErrors('estrategiaLiquidacion')"
            :error-messages="getInputErrors('estrategiaLiquidacion')"
            color="secondary"
            :rules="required"
        ></v-select>
      </v-col>

      <template v-if="form.estrategiaLiquidacion === 'POR_VUELTA'">
        <v-col cols="12">
          <v-row
              v-for="(vuelta, index) in form.comisionPorVuelta"
              :key="index"
              align="center"
          >
            <v-col cols="12" sm="5">
              <v-text-field
                  prepend-icon="loop"
                  :name="`comisionPorVuelta.${index}.numeroVuelta`"
                  v-model.number="vuelta.numeroVuelta"
                  type="number"
                  min="1"
                  :label="$t('cobrox.compra.labels.numeroVuelta')"
                  :error="hasInputErrors(`comisionPorVuelta.${index}.numeroVuelta`)"
                  :error-messages="getInputErrors(`comisionPorVuelta.${index}.numeroVuelta`)"
                  color="secondary"
                  :rules="vueltaRules(index)"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="5">
              <v-text-field
                  prepend-icon="percent"
                  :name="`comisionPorVuelta.${index}.porcentaje`"
                  v-model.number="vuelta.porcentaje"
                  type="number"
                  min="0"
                  max="100"
                  :label="$t('cobrox.compra.labels.porcentajeComision')"
                  :error="hasInputErrors(`comisionPorVuelta.${index}.porcentaje`)"
                  :error-messages="getInputErrors(`comisionPorVuelta.${index}.porcentaje`)"
                  color="secondary"
                  :rules="percentRules"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="2">
              <v-btn
                  icon
                  color="error"
                  :disabled="form.comisionPorVuelta.length <= 1"
                  @click="removeVuelta(index)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-btn text color="secondary" @click="addVuelta">
            <v-icon left>add</v-icon>
            {{ $t('cobrox.compra.labels.agregarVuelta') }}
          </v-btn>
        </v-col>
      </template>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="sort"
            name="orden"
            v-model.number="form.orden"
            type="number"
            :label="$t('cobrox.compra.labels.orden')"
            :placeholder="$t('cobrox.compra.labels.orden')"
            :error="hasInputErrors('orden')"
            :error-messages="getInputErrors('orden')"
            color="secondary"

        ></v-text-field>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import {DayjsMixin, DateInput} from "@dracul/dayjs-frontend";

export default {
  name: "CompraForm",
  mixins: [InputErrorsByProps, RequiredRule, DayjsMixin],
  components: {DateInput},
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    percentRules() {
      return [
        v => (v !== null && v !== undefined && v !== '') || this.$t('validation.required'),
        v => (!Number.isNaN(Number(v)) && Number(v) >= 0 && Number(v) <= 100) || '0 - 100'
      ]
    }
  },
  created() {
    this.ensureFormDefaults()
  },
  watch: {
    'form.estrategiaLiquidacion'() {
      this.ensureFormDefaults()
    },
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    ensureFormDefaults() {
      if (!this.value.estrategiaLiquidacion) {
        this.$set(this.value, 'estrategiaLiquidacion', 'TRADICIONAL')
      }
      if (!this.value.comisionPorVuelta) {
        this.$set(this.value, 'comisionPorVuelta', [])
      }
      if (!Array.isArray(this.value.comisionPorVuelta)) {
        this.$set(this.value, 'comisionPorVuelta', this.normalizeLegacyComisionPorVuelta(this.value.comisionPorVuelta))
      }
      if (this.value.estrategiaLiquidacion === 'POR_VUELTA' && this.value.comisionPorVuelta.length === 0) {
        this.value.comisionPorVuelta.push({numeroVuelta: 1, porcentaje: null})
      }
    },
    normalizeLegacyComisionPorVuelta(comisionPorVuelta) {
      if (Array.isArray(comisionPorVuelta)) return comisionPorVuelta
      if (!comisionPorVuelta) return []
      return [
        {numeroVuelta: 1, porcentaje: comisionPorVuelta.vuelta1},
        {numeroVuelta: 2, porcentaje: comisionPorVuelta.vuelta2},
        {numeroVuelta: 3, porcentaje: comisionPorVuelta.vuelta3},
        {numeroVuelta: 4, porcentaje: comisionPorVuelta.vuelta4Mas}
      ].filter(item => item.porcentaje !== null && item.porcentaje !== undefined && item.porcentaje !== '')
    },
    addVuelta() {
      const maxVuelta = this.form.comisionPorVuelta.reduce((max, item) => Math.max(max, Number(item.numeroVuelta) || 0), 0)
      this.form.comisionPorVuelta.push({numeroVuelta: maxVuelta + 1, porcentaje: null})
    },
    removeVuelta(index) {
      if (this.form.comisionPorVuelta.length <= 1) return
      this.form.comisionPorVuelta.splice(index, 1)
    },
    vueltaRules(index) {
      return [
        v => (v !== null && v !== undefined && v !== '') || this.$t('validation.required'),
        v => Number.isInteger(Number(v)) && Number(v) >= 1 || this.$t('cobrox.compra.validation.numeroVuelta'),
        v => this.form.comisionPorVuelta.findIndex(item => Number(item.numeroVuelta) === Number(v)) === index || this.$t('cobrox.compra.validation.vueltaRepetida')
      ]
    }
  },
  data() {
    return {
      fechaCompraDateMenu: false,
      estrategiasLiquidacion: [
        {text: 'Tradicional', value: 'TRADICIONAL'},
        {text: 'Por vuelta', value: 'POR_VUELTA'}
      ]
    }
  }
}
</script>

<style scoped>

</style>
